import { render, staticRenderFns } from "./CardProject.vue?vue&type=template&id=4b602d94&"
import script from "./CardProject.vue?vue&type=script&lang=js&"
export * from "./CardProject.vue?vue&type=script&lang=js&"
import style0 from "./CardProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports